import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  deleteManyProductionInstances,
  deleteManyProductionInstancesFailure,
  deleteManyProductionInstancesSuccess
} from './production-instance.delete-many.actions';
import {ProductionInstancesService} from '../../../services/api/production-instances/production-instances.service';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';
import {loadVmixServers, manyProductionInstancesStatusChanged} from '../actions/vmix-servers.actions';


@Injectable()
export class ProductionInstanceDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyProductionInstances$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyProductionInstances),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<ProductionInstance>[] = ids
            .map((id: UUID): Observable<ProductionInstance> =>
              this.service.delete(id)
            );

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyProductionInstancesSuccess({ids: ids})),
              catchError((error: any) => of(deleteManyProductionInstancesFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyProductionInstancesSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyProductionInstancesSuccess),
        tap(() =>
          this.snackBar.open('Production Instances deletion successfully started', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) =>
          manyProductionInstancesStatusChanged({ids: data.ids, status: 'deleting'})
        )
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyProductionInstancesFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyProductionInstancesFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete production instances: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadVmixServers())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: ProductionInstancesService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
